import { store } from '../../store';
import { updateConversationInHistory } from '../../store/chat/slice';
import { SocketMessage } from '../types';
import { ClientConversation, ConversationStatus } from '../../store/chat/types';
import { sendConversationStatus } from '../publishers/sendConversationStatus';
import { getCompaniesByIds } from '../../api/companyApi';

export interface AssistantChatMessagePayload {
  conversation: ClientConversation;
}

export async function assistantMessageHandler(
  message: SocketMessage<AssistantChatMessagePayload>,
): Promise<void> {
  const payload = message.payload as AssistantChatMessagePayload;
  const conversation = payload.conversation;

  if (!payload || !conversation) return;

  const state = store.getState();
  const currentConversation = state.chat.conversation;

  const isNewAnswer = conversation.status === ConversationStatus.NewAnswer;
  const isCurrentConversation = currentConversation && currentConversation.id === conversation.id;
  // message still answering = answering
  // message is new answer and currently viewing = already seen
  // in history = notify about new answer
  const newStatus =
    conversation.status === ConversationStatus.Answering
      ? ConversationStatus.Answering
      : isNewAnswer && isCurrentConversation
        ? ConversationStatus.Inactive
        : ConversationStatus.NewAnswer;

  // if it's the current conversation, update it to seen
  if (isNewAnswer && isCurrentConversation) {
    await sendConversationStatus(conversation.id, newStatus);
  }

  let filtered_company_tickers;
  if (conversation.filtered_company_ids && conversation.filtered_company_ids.length > 0) {
    const companies = await getCompaniesByIds(conversation.filtered_company_ids);
    filtered_company_tickers = companies.map((company) => company.ticker);
  }

  store.dispatch(
    updateConversationInHistory({
      id: conversation.id,
      updates: { ...conversation, status: newStatus, filtered_company_tickers },
    }),
  );
}
